module.exports = __webpack_public_path__ + "media/images/locations/sm/london-0cdce8b323dc816f5faebdc154ec2561.jpg";